<template>
  <Combobox
    as="div"
    :nullable="true"
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    class="relative">
    <ComboboxInput
      v-bind="$attrs"
      @input="onInputChange"
      @click="openOptionsOnClick"
      :displayValue="(item) => item?.name"
      :placeholder="$t('components.form.combobox.placeholder')"
      autocomplete="off"
      class="form-input" />
    <ComboboxOptions class="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md border border-white/10 bg-gray-900 shadow-lg shadow-black/30">
      <ComboboxOption v-for="option in filteredOptions" :key="option.id" :value="option" v-slot="{ active }">
        <div
          class="cursor-pointer border border-transparent px-3 py-2 text-sm text-gray-200"
          :class="active ? 'dropdown-option-active' : ''"
        >
          {{ option.name }}
        </div>
      </ComboboxOption>

      <div v-if="filteredOptions.length === 0" class="px-3 py-2 text-sm text-gray-500">
        {{ $t('components.form.combobox.nothingFound') }}
      </div>
    </ComboboxOptions>
  </Combobox>
</template>

<script>
import {
  Combobox,
  ComboboxInput,
  ComboboxOptions,
  ComboboxOption,
} from '@headlessui/vue'

export default {
  inheritAttrs: false,
  emits: ['update:modelValue'],
  data() {
    return {
      query: '',
    }
  },
  props: {
    modelValue: {
      type: Object,
      default: null,
    },
    availableOptions: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Combobox,
    ComboboxInput,
    ComboboxOptions,
    ComboboxOption,
  },
  methods: {
    onInputChange(event) {
      this.query = event.target.value
    },
    openOptionsOnClick(event) {
      requestAnimationFrame(() => {
        event.target.dispatchEvent(new Event('input', { bubbles: true }))
      })
    },
  },
  computed: {
    normalizedQuery() {
      return this.query.trim().toLowerCase()
    },
    filteredOptions() {
      return this.normalizedQuery === ''
        ? this.availableOptions
        : this.availableOptions.filter((option) => {
          return option.name.toLowerCase().includes(this.normalizedQuery)
        })
    },
  },
}
</script>
